export default "__VITE_ASSET__47c1f260__"